export function getIndexPath(){
    
    let indexPath = window.location.href;

    console.log(indexPath);

    // REMINDER: My webpage have two domain name: https://honkypie.com and https://www.honkypie.com 
    if(indexPath.includes("https://honkypie.com/")){

        indexPath = indexPath.replace('https://honkypie.com', '');   // Es el URL sin la primera parte que es el nombre del domain

    }else if(indexPath.includes("https://www.honkypie.com/")){

        indexPath = indexPath.replace('https://www.honkypie.com', '');   // Es el URL sin la primera parte que es el nombre del domain

    }else{  // testing con localhost:3000

        indexPath = indexPath.replace(process.env.REACT_APP_DOMAIN_URL, '');   // Es el URL sin la primera parte que es el nombre del domain
    }

    return indexPath;
}


export function getUrlLanguage() {

    // Check language: Ver si esta en la página en español (lee el url y checa que el valor del path index 0 sea 'es').
    let indexPath = getIndexPath();

    return indexPath.substring(0,3);
}


export function getDomainWithLanguageURL(link) {

    if(getUrlLanguage() === "/es"){ // Si el lenguaje actual es español, entonces
        
        return process.env.REACT_APP_DOMAIN_URL + "/es"; 

    }else{ // Si el lenguaje actual es inglés, entonces

        return process.env.REACT_APP_DOMAIN_URL; 
    }
};


